import { cx } from '@emotion/css';
import { forwardRef } from 'react';
import TextField from '@mui/material/TextField';

import FieldGroup from '../field-group';

import { InputBaseProps } from './types';
import { inputCx } from './styles';

const InputBase = forwardRef<HTMLDivElement, InputBaseProps>((props, ref) => {
  const {
    name,
    helperText,
    className,
    inputClassName,
    type,
    InputLabelProps,
    label,
    isInvalid,
    error,
    ...resProps
  } = props;

  return (
    <FieldGroup
      invalid={isInvalid}
      error={error}
      helperText={helperText}
      className={className}
      ref={ref}
      name={name}
    >
      <TextField
        {...resProps}
        type={type}
        error={isInvalid}
        label={label}
        variant='standard'
        className={cx(inputCx, inputClassName)}
        InputLabelProps={{
          ...InputLabelProps,
          shrink: true,
        }}
      />
    </FieldGroup>
  );
});

export default InputBase;
